export const domPurifyHooks = {
  afterSanitizeAttributes: (node) => {
    if (node.tagName === 'IMG') {
      node.setAttribute('referrerpolicy', 'no-referrer')
    }
  },
}
